// extracted by mini-css-extract-plugin
module.exports = {"default":"idt-modalfooter_default__38qhv"};